// extracted by mini-css-extract-plugin
export var createdDate = "_jc-1";
export var divider = "_jc-2";
export var headerDivider = "_jc-3";
export var messagesCard = "_jc-0";
export var messagesContainer = "_jc-7";
export var messagesContainerWrapper = "_jc-4";
export var pointerCapturingButtonBoxes = "_jc-a";
export var showLeftPanelButton = "_jc-9";
export var showMoreButton = "_jc-c";
export var showMoreButtonContainer = "_jc-b";
export var summaryTitle = "_jc-6";
export var systemMessageCardWrapper = "_jc-d";
export var topButtons = "_jc-8";
export var withPadding = "_jc-5";